/** Roles accordion group for Hired Equipment submissions and vendor master. */
export const HIRED_EQUIPMENT_MODULE = 'Hired Equipment';

/**
 * Submission workflow (`submission:hired_equipment_*` / `he_manage` / `he_revisions`)
 * plus vendor-master (`heMaster:*`) keys shown together in Roles.
 */
export function isHiredEquipmentFeaturePermission(key: string): boolean {
  return (
    key.startsWith('submission:hired_equipment_') ||
    key === 'submission:he_manage' ||
    key === 'submission:he_revisions' ||
    key.startsWith('heMaster:')
  );
}

/**
 * V2-071 (LANG-12): category names in the Standards vocabulary. The stored module names are
 * older ("Form Submissions", "Routine Works"); the Roles screens show the standard term.
 */
const MODULE_DISPLAY_NAMES: Record<string, string> = {
  'Form Submissions': 'Submissions',
  'Routine Works': 'Routine Work',
  USER: 'Users',
};

/** Roles UI group name — remaps HE keys even if the API still returns an older module. */
export function displayModuleForPermission(key: string, fallbackModule: string): string {
  if (isHiredEquipmentFeaturePermission(key)) {
    return HIRED_EQUIPMENT_MODULE;
  }
  // One name for the widget category on Create/Edit Role and in Show Details (W-M12).
  if (key.startsWith('widget:') || fallbackModule === 'Widget Permissions') {
    return 'Widgets';
  }
  return MODULE_DISPLAY_NAMES[fallbackModule] ?? fallbackModule;
}
